import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { from, map, Observable, of, catchError } from 'rxjs';
import { AuthService } from '../../service/auth/auth.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccessAuthGuard {

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (environment.UNSECURE) {
      return true;
    }

    console.debug('[Guard] AccessAuthGuard — route:', route.routeConfig?.path);
    return from(this.authService.isLoggedIn()).pipe(
      map(isUserLogged => {
        const hasManagerAccess = this.authService.hasManagerAccess();
        console.debug('[Guard] isLoggedIn:', isUserLogged, '| hasManagerAccess:', hasManagerAccess);

        if (isUserLogged && hasManagerAccess) {
          if (route.routeConfig.path === 'login') {
            this.router.navigate([this.authService.homeRoute()]);
          }
          return true;
        }

        // Not logged in on the login page itself — allow access (avoid redirect loop)
        if (route.routeConfig.path === 'login') {
          return true;
        }

        if (isUserLogged && !hasManagerAccess) {
          console.debug('[Guard] Logged in but no manager access — logging out');
          this.authService.logout(`${environment.MANAGER_FRONTEND_URL}/login?reason=no-access`);
        } else {
          console.debug('[Guard] Not logged in — redirecting to login');
          this.router.navigate(['login']);
        }

        return false;
      }),
      catchError((err) => {
        console.debug('[Guard] Error in canActivate:', err);
        this.router.navigate(['login']);
        return of(false);
      })
    );
  }
}
